import { Component, OnInit } from '@angular/core';
import { VendorService } from '../../../../app/_services/vendor.services';
import { SnackbarService } from '../../../_service/message-service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { ManageMappingService } from '../../user-management/services/manage-mapping.service';
import { Role } from 'src/app/util/enums/role.enum';
import { MenuRouteID } from '../../header/menu-item/nav-item';
import { AuthenticationService } from 'src/app/_services';

@Component({
  selector: 'telio-create-vendor',
  templateUrl: './create-vendor.component.html',
  styleUrls: ['./create-vendor.component.scss'],
})
export class CreateVendorComponent implements OnInit {
  vendorId;
  editVendor;
  userDetails: any = {};
  adminrole: any;
  tenantadminrole:any;
  iscreate = true;
  listedCountries = ['in'];
  userId;
  loadMappingTab = false;
  mappingTab = false;
  routedComponent: string;
  groupType = '';
  disableMapping = false;
  fromCmsUser = true
  availableTabs = [
    { id: MenuRouteID.TABS.OPERATOR_DETAILS, enable: false },
    { id: MenuRouteID.TABS.MAPPING, enable: false },
  ];
  isMyProfile = false;
  isEdit;

  constructor(
    private vendorservice: VendorService,
    private router: Router,
    private toastr: SnackbarService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private userInfoService: UserInfoService,
    readonly manageMappingService: ManageMappingService,
    private authService: AuthenticationService
  ) {
    this.route.queryParams.subscribe(params => {
      this.listedCountries = params['listedCountries'];
      this.disableMapping = !!params['disableMapping'] ? params['disableMapping'] : false;
      this.isEdit=params['isEdit'];
    });
  }

  ngOnInit() {
    this.availableTabs = this.userInfoService.getPermittedTabs(+this.route.snapshot.paramMap.get('routeID'), this.availableTabs);
    let tabExists = this.availableTabs.filter(res => res.enable);
    !tabExists || tabExists.length == 0 ? this.toastr.info(this.translate.instant('unAuthorized')) : '';
    this.route.queryParams.subscribe(params => {
      this.vendorId = params['vendorId'];
      !!this.vendorId && this.authService.setCreatedOperatorId(this.vendorId)
      this.groupType = params['groupType'];
      this.isMyProfile = params['isMyProfile'];
      this.isEdit=params['isEdit'];
      this.getvendorinfobyvendorid();
      this.routedComponent = params['routedName'];
      if (params['station']){
      this.editVendor = JSON.parse(params['station']);
      this.userId = this.editVendor.userId
      this.authService.setCmsUserID = this.userId
      this.groupType = this.editVendor.group
      }
      this.mappingTab = !!params.mappingTab ? JSON.parse(params.mappingTab) : false
    });
    this.userDetails = this.userInfoService.userDetails;
    this.adminrole = this.userInfoService.isAdminGroup();
    this.tenantadminrole=this.userInfoService.groups.includes(Role.SUPERADMIN)
  }

   getvendorinfobyvendorid() {
    this.vendorservice.getvendorinfobyvendorid(this.vendorId, this.groupType).subscribe(res => {
      if (res.status_code != "500") {
        this.editVendor = res;
     }
     })
   }

  backButton() {
    !this.adminrole && this.vendorId ? this.router.navigate(['/dashboard/home']) : this.reDirectButton();
  }

  reDirectButton() {
    this.routingScreen();
  }

  enableTab2() {
    this.disableMapping = false;
  }

  routingScreen() {
    if (this.routedComponent == 'operators') {
      this.router.navigate(['/dashboard/operators', { routeID: this.route.snapshot.paramMap.get('routeID') }])
    }
    else {
      this.router.navigate(['/dashboard/user-management/users', { routeID: this.route.snapshot.paramMap.get('routeID') }])
    }
  }

  tabClick(tab) {
    if (tab.index == 1) {
      this.loadMappingTab = true;
    }
  }
}
